import classNames from 'classnames';

const CardDocumentType = ({ docType, expand }) => {
  const docTypeClass = classNames({
    card__docType: !expand,
    'card__docType--expanded': expand,
  });

  return <div className={docTypeClass}>{docType === 1 ? 'Norma Técnica' : 'Desenho Padrão'}</div>;
};

export default CardDocumentType;
